let _cacheOs = undefined;
export const getOs = () => {
    if (typeof _cacheOs !== 'undefined') {
        return _cacheOs;
    }
    const DEFAULT_OS = 'mac';
    let res = DEFAULT_OS;
    if (typeof window === 'undefined') {
        res = DEFAULT_OS;
        return res;
    }
    if (window && window.electronLib) {
        const uaStr = navigator.userAgent;
        if (/windows\s*(?:nt)?\s*[._\d]*/i.test(uaStr)) {
            const DEFAULE_WIN_OS = 'win';
            if (window && window.process) {
                if (window.process.arch === 'ia32') {
                    res = 'win32';
                }
                else if (window.process.arch === 'x64') {
                    res = 'win';
                }
                else {
                    res = DEFAULE_WIN_OS;
                }
            }
            else {
                res = DEFAULE_WIN_OS;
            }
        }
        else if (/mac os x/i.test(uaStr)) {
            res = 'mac';
        }
    }
    _cacheOs = res;
    return res;
};
export const getWebOsByUA = () => {
    const DEFAULT_OS = 'win';
    let res = DEFAULT_OS;
    if (typeof navigator === 'undefined' || !navigator || !navigator.userAgent) {
        return res;
    }
    const uaStr = navigator.userAgent;
    if (/windows\s*(?:nt)?\s*[._\d]*/i.test(uaStr)) {
        res = 'win';
    }
    else if (/mac os x/i.test(uaStr)) {
        res = 'mac';
    }
    return res;
};
